import api from './api';

// Lista de modelos disponibles de OpenAI
export const OPENAI_MODELS = [
  { id: 'gpt-5', name: 'GPT-5' },
  { id: 'gpt-5-mini', name: 'GPT-5-mini' },

];

const openaiService = {
  // Obtener la configuración actual de OpenAI
  getConfig: async () => {
    try {
      const response = await api.get('/api/admin/config/openai');
      console.log('Configuración OpenAI obtenida:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al obtener la configuración de OpenAI:', error);
      // Si hay un error, devolvemos una configuración por defecto
      return {
        modelName: 'gpt-5-mini',
        maxTokens: 2000,
        temperature: 1.0,
        endpoint: 'https://api.openai.com/v1/'
      };
    }
  },
  
  // Obtener solo el modelo actual
  getCurrentModel: async () => {
    try {
      const config = await openaiService.getConfig();
      return config.modelName;
    } catch (error) {
      console.error('Error al obtener el modelo actual de OpenAI:', error);
      return 'gpt-5-mini';
    }
  },
  
  // Actualizar la configuración completa
  updateConfig: async (config) => {
    try {
      const response = await api.put('/api/admin/config/openai', config);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar la configuración de OpenAI:', error);
      throw error;
    }
  },
  
  // Actualizar solo el modelo usando el endpoint específico
  updateModel: async (modelId) => {
    try {
      console.log(`Actualizando modelo a: ${modelId}`);
      
      // Usamos el endpoint específico para actualizar solo el modelo
      const response = await api.put('/api/admin/config/openai/model', {
        modelName: modelId
      });
      
      console.log('Respuesta del servidor:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar el modelo de OpenAI:', error);
      throw error;
    }
  },
  
  // Obtener todos los modelos disponibles
  getAvailableModels: () => {
    return OPENAI_MODELS;
  }
};

export default openaiService;
